import range from "lodash/range";
import classNames from "classnames";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

// components
import Link from "@/components/Link";

// interfaces
import { ILandingPagination } from "./ILandingPagination";

// assets
import styles from "@/assets/styles/components/landing-pagination.module.scss";

const LandingPagination = ({ pages = 0, page = 0, paginationUrl }: ILandingPagination) => {
  const renderPages = () =>
    // eslint-disable-next-line implicit-arrow-linebreak
    [
      page <= 2 ? false : 1,
      page > 2 && "dots",
      ...range(page - 1, page + 4).filter(
        (paginationItem) => paginationItem > 0 && paginationItem <= pages
      ),
      page < pages - 3 && "dots",
      page >= pages - 3 ? false : pages
    ]
      .filter((x) => x !== false)
      .map((paginationItem, index) =>
        // eslint-disable-next-line implicit-arrow-linebreak
        paginationItem === "dots" ? (
          <div className={styles["locl-landing-pagination__dots"]} key={`dots-${index}`}>
            ...
          </div>
        ) : (
          <Link
            href={paginationItem === 1 ? paginationUrl : `${paginationUrl}${paginationItem}`}
            className={classNames(styles["locl-landing-pagination__item"], {
              [styles["locl-landing-pagination__item_active"]]:
                (paginationItem as number) === page
            })}
            key={`paginationItem-${index}`}
          >
            {paginationItem}
          </Link>
        )
      );

  return (
    <div className={styles["locl-landing-pagination"]}>
      {page !== 1 && (
        <Link
          href={`${paginationUrl}${(page as number) - 1}`}
          className={styles["locl-landing-pagination__arrow"]}
          data-testid="locl-landing-pagination-arrow-prev"
        >
          <FiChevronLeft className={styles["locl-landing-pagination__arrow-icon"]} />
        </Link>
      )}
      {renderPages()}
      {page !== pages && (
        <Link
          href={`${paginationUrl}${page + 1}`}
          className={styles["locl-landing-pagination__arrow"]}
          data-testid="locl-landing-pagination-arrow-next"
        >
          <FiChevronRight className={styles["locl-landing-pagination__arrow-icon"]} />
        </Link>
      )}
    </div>
  );
};

export default LandingPagination;
